import { render, staticRenderFns } from "./bitacora.vue?vue&type=template&id=4b438d4e"
import script from "./bitacora.js?vue&type=script&lang=js&external"
export * from "./bitacora.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports